// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.search-results {
  max-height: 400px !important;
  z-index: 1;
  box-shadow: 0px 0px 3px;
}

.search-results  > div {
    background-color: #fff !important;
  }

.schedule-header-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
}

.schedule-header-row  > .h4-title {
    margin-bottom: 0;
  }

.schedule-filter {
  display: flex;
  align-items: center;
  gap: 10px;
}

.calendar-navigation {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  margin: 40px 0 5px;
}

.calendar-navigation  > .calendar-month-title {
    display: flex;
    align-items: center;
    gap: 10px;
  }

:is(.calendar-navigation > .calendar-month-title)  > h2 {
      color: var(--texto-destaque);
      font-size: 18px;
      font-weight: 800;
      margin-left: 5px;
    }

:is(:is(.calendar-navigation > .calendar-month-title) > h2)::first-letter {
        text-transform: uppercase;
      }

.calendar-navigation  > div > button {
    background: none;
    padding: 0 5px;
    border: none;
  }

:is(.calendar-navigation > div > button) .i {
      border: 1.8px solid var(--texto-destaque);
      border-radius: 50%;
      font-size: 20px;
      padding: 6px 10px;
      color: var(--texto-destaque);

    }

.calendar-navigation.day-mode {
  justify-content: flex-end;
}

.calendar-month-count {
  background-color: var(--texto-destaque);
  color: #fff;
  font-size: 12px;
  font-weight: 700;
  padding: 3px 10px;
  border-radius: 999px;
  white-space: nowrap;
}

.calendar-grid {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  gap: 0;
  /* Remove o espaçamento entre os dias */
  width: 100%;
  height: 100%;
  /* Garante que o grid ocupe toda a altura */
  overflow-y: auto;
  border-collapse: collapse;
  /* Faz com que as bordas fiquem encostadas */
}

.calendar-header {
  font-weight: bold;
  text-align: center;
  padding: 10px;
}

.calendar-day {
  background: #fff;
  padding: 10px;
  text-align: center;
  cursor: pointer;
  position: relative;
  min-height: 100px;
  border: 1px solid var(--borda);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  min-width: 120px;
  /* Largura mínima */
  box-sizing: border-box;
}

.calendar-day.active:hover {
  background: #e2e2e2;
}

.calendar-day span {
  display: block;
  margin-bottom: 5px;
}

.appointment-summary {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.appointment-summary span {
  font-size: 12px;
  font-weight: bold;
  padding: 2px 4px;
  border-radius: 4px;
  color: white;
}

.summary-pending {
  background-color: #f0ad4e;
}

.summary-done {
  background-color: #5cb85c;
}

.summary-canceled {
  background-color: #d9534f;
}

.summary-warning {
  background-color: #f7dc6f;
}

.summary-expired {
  background-color: #d9534f;
}

.calendar-day .appointment-tag {
  color: var(--texto);
  margin-top: 5px;
  border-radius: 5px;
  padding: 2px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 12px;
  width: 100%;
  text-align: center;
}

/* Cores dos status de agendamento */
.appointment-done {
  background-color: lightgreen;
  padding: 0 4px;
  border-radius: 8px;
}

.appointment-pending {
  background-color: lightsalmon;
  padding: 0 4px;
  border-radius: 8px;
}

.appointment-canceled {
  background-color: #d9534f;
  color: #fff;
  padding: 0 4px;
  border-radius: 8px;
}

.appointment-expired {
  background-color: lightcoral;
  padding: 0 4px;
  border-radius: 8px;
}

.appointment-warning {
  background-color: rgb(248, 248, 115);
  padding: 0 4px;
  border-radius: 8px;
}

.status-agendamentos {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #ccc;
  margin-top: 10px;
}

.status-agendamentos  > p:nth-of-type(1) {
    width: 200px;
    font-size: 15px;
  }

.status-agendamentos  > p:nth-of-type(2) {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    font-size: 14px;
  }

.status-agendamentos  > button {
    background: none;
    color: var(--texto-destaque);
    padding: 0;
    font-size: 16px;
    border: none;

    
  }

.add-appointment-button {
  margin: -9px 20px 0 0;
}

.add-appointment-button  > button {
    background: none;
    color: var(--texto-destaque);
    font-weight: 400;
    border: 1px solid var(--texto-destaque);
    padding: 4px 10px;
    display: flex;
    align-items: center;
    gap: 6px;
  }



/* Hover effects */
.appointment-pending:hover {
  background-color: rgb(252, 133, 86);
}

.appointment-done:hover {
  background-color: rgb(115, 237, 115);
}

.appointment-canceled:hover {
  background-color: #c9302c;
}

.appointment-expired:hover {
  background-color: rgb(239, 109, 109);
}

.appointment-warning:hover {
  background-color: yellow;
}


/* Resposta a dispositivos menores */
@media (max-width: 800px) {
  .calendar-day {
    min-width: 0;
    max-width: unset;
    padding: 6px 4px;
    min-height: 84px;
  }

  .calendar-grid {
    grid-template-columns: repeat(7, minmax(0, 1fr));
  }

  .calendar-header {
    padding: 8px 4px;
    font-size: 16px;
  }

  .calendar-day > span {
    font-size: 14px;
    margin-bottom: 3px;
  }

  .appointment-summary {
    width: 100%;
    gap: 3px;
  }

  .appointment-summary span {
    width: 100%;
    font-size: 10px;
    padding: 2px 3px;
    line-height: 1.2;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}

@media (max-width: 500px) {
  .calendar-day {
    min-width: 0;
    max-width: unset;
  }
}

.appointment-details {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-top: 40px;
}

.appointment-details-modal {
  display: flex;
  flex-direction: column;
  gap: 14px;
  padding: 4px 2px;
}

.appointment-details-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  border: 1px solid var(--ui-border);
  border-radius: 12px;
  background: #f8faff;
  padding: 12px;
}

.appointment-details-header h4 {
  margin: 4px 0 0;
  color: var(--ui-text);
}

.appointment-details-label {
  margin: 0;
  font-size: 11px;
  font-weight: 700;
  color: var(--ui-muted);
  text-transform: uppercase;
  letter-spacing: .4px;
}

.appointment-details-status {
  font-size: 12px;
  font-weight: 700;
  border-radius: 999px;
  padding: 6px 10px;
  white-space: nowrap;
}

.appointment-details-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px;
}

.appointment-details-card {
  display: flex;
  flex-direction: column;
  gap: 4px;
  border: 1px solid var(--ui-border);
  border-radius: 10px;
  background: #fff;
  padding: 10px;
}

.appointment-details-card span {
  font-size: 11px;
  font-weight: 700;
  color: var(--ui-muted);
  text-transform: uppercase;
}

.appointment-details-card strong {
  color: var(--ui-text);
  font-size: 14px;
  overflow-wrap: anywhere;
  word-break: break-word;
}

.appointment-details-block {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.appointment-details-text {
  border: 1px solid var(--ui-border);
  border-radius: 10px;
  background: #fff;
  padding: 10px;
  min-height: 58px;
  white-space: pre-wrap;
  overflow-wrap: anywhere;
  word-break: break-word;
}

.appointment-form {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

@media (max-width: 500px) {

.appointment-form {
    margin-top: 0;
}
  }

.appointment-create-modal {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.appointment-create-block {
  border: 1px solid #e4eaf4;
  border-radius: 12px;
  background: #fff;
  padding: 10px 12px;
}

.appointment-selected-internal {
  margin-top: 8px;
  border-top: 1px solid #edf1f7;
  padding-top: 8px;
}

.appointment-create-form .appointment-details-grid {
  border: 1px solid #e4eaf4;
  border-radius: 12px;
  background: #fff;
  padding: 10px;
  gap: 12px;
}

.appointment-create-form .appointment-details-card {
  border: none;
  background: transparent;
  padding: 0;
  border-radius: 0;
  gap: 4px;
}

.appointment-create-form .appointment-details-card select,
.appointment-create-form textarea {
  width: 100%;
  margin-top: 6px;
}

.appointment-virtual-card {
  justify-content: center;
}

.appointment-virtual-field {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-top: 6px;
}

.appointment-virtual-label {
  font-size: 13px;
  font-weight: 600;
  color: #6b7a90;
  min-width: 32px;
  text-align: center;
}

.appointment-virtual-label.active {
  color: #1c3faa;
}

.appointment-virtual-toggle {
  position: relative;
  width: 44px;
  height: 24px;
  display: inline-block;
}

.appointment-virtual-toggle input {
  opacity: 0;
  width: 0;
  height: 0;
}

.appointment-virtual-slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #cfd8ee;
  transition: 0.2s ease;
  border-radius: 999px;
}

.appointment-virtual-slider::before {
  position: absolute;
  content: "";
  height: 18px;
  width: 18px;
  left: 3px;
  top: 3px;
  background-color: #fff;
  transition: 0.2s ease;
  border-radius: 50%;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
}

.appointment-virtual-toggle input:checked + .appointment-virtual-slider {
  background-color: #1c6ef2;
}

.appointment-virtual-toggle input:checked + .appointment-virtual-slider::before {
  transform: translateX(20px);
}

.appointment-create-actions {
  display: flex;
  justify-content: flex-end;
}

.appointment-create-actions .add-button {
  min-width: 210px;
  border-radius: 10px;
}

.appointment-details .buttons-agenda-view {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  margin-top: 20px;
}

:is(.appointment-details .buttons-agenda-view)  > button {
    width: 100%;
    border-radius: 12px;
  }

:is(.appointment-details .buttons-agenda-view) .btn-atender {
    background-color: var(--verde);
    color: #fff;
    border: none;
  }

:is(.appointment-details .buttons-agenda-view) .btn-cancelar {
    background-color: var(--Vermelho);
    color: #fff;
    border: none;
  }

.appointment-form .form-group button {
  background-color: var(--verde);
  color: #fff;
  border: none;
}

.calendar-month-actions {
  display: flex;
  align-items: center;
}

.day-view-actions {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
  justify-content: flex-end;
}

.day-view-actions > button {
  display: flex;
  align-items: center;
  gap: 6px;
  border: 1px solid var(--texto-destaque);
  color: var(--texto-destaque);
  background: #fff;
  border-radius: 10px;
  padding: 8px 12px;
  font-size: 14px;
}

.day-view-actions > button .icon {
  width: 14px;
  height: 14px;
}

.day-back-icon {
  font-size: 14px;
}

.day-schedule-container {
  width: 100%;
  background: #fff;
  border: 1px solid var(--borda);
  border-radius: 12px;
  overflow: hidden;
}

.day-schedule-header {
  display: flex;
  align-items: baseline;
  gap: 10px;
  padding: 14px 16px;
  border-bottom: 1px solid var(--borda);
  background: #f7f9fc;
}

.day-schedule-header > p {
  margin: 0;
  font-size: 12px;
  font-weight: 700;
  color: #6e7c91;
}

.day-schedule-header > h3 {
  margin: 0;
  font-size: 22px;
  color: var(--texto-destaque);
}

.day-schedule-grid {
  max-height: 68vh;
  overflow-y: auto;
}

.day-schedule-list {
  padding: 10px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.day-event-card {
  display: flex;
  justify-content: space-between;
  gap: 8px;
  align-items: flex-start;
  border: 1px solid #dbe4f2;
  border-left: 4px solid #265daf;
  border-radius: 8px;
  padding: 8px 10px;
  background: #fafdff;
  cursor: pointer;
  transition: transform 0.15s ease, box-shadow 0.15s ease, background-color 0.15s ease;
}

.day-event-card:hover {
  background: #f2f7ff;
  transform: translateY(-1px);
  box-shadow: 0 4px 10px rgba(38, 93, 175, 0.12);
}

.day-event-card:focus-visible {
  outline: 2px solid var(--texto-destaque);
  outline-offset: 2px;
}

.day-event-card.day-card-appointment-done {
  border-left-color: #5cb85c;
}

.day-event-card.day-card-appointment-pending {
  border-left-color: #f0ad4e;
}

.day-event-card.day-card-appointment-warning {
  border-left-color: #f7dc6f;
}

.day-event-card.day-card-appointment-expired {
  border-left-color: #d9534f;
}

.day-event-card.day-card-appointment-canceled {
  border-left-color: #8e8e8e;
}

.day-event-time {
  margin: 0;
  font-size: 12px;
  font-weight: 700;
  color: #5f6f8a;
}

.day-event-title {
  margin: 2px 0 0;
  font-weight: 700;
  color: #1f4280;
}

.day-event-subtitle {
  margin: 2px 0 0;
  font-size: 13px;
  color: #405371;
}

.day-event-actions {
  display: flex;
  gap: 8px;
  align-items: center;
  justify-content: flex-end;
  flex-wrap: nowrap;
}

.day-event-actions .appointment-item {
  width: auto;
  max-width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  flex-shrink: 1;
}

@media (max-width: 800px) {
  .schedule-header-row {
    flex-wrap: wrap;
    gap: 10px;
  }

  .calendar-navigation {
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
    margin: 16px 0 10px;
  }

  .calendar-navigation .calendar-month-title h2 {
    margin-left: 0;
    font-size: 18px;
  }

  .calendar-navigation.day-mode {
    align-items: flex-end;
  }

  .day-view-actions {
    width: 100%;
    justify-content: flex-end;
  }

  .day-view-actions > button {
    justify-content: center;
  }

  .day-event-card {
    flex-direction: column;
    gap: 6px;
    padding: 8px;
  }

  .day-event-title {
    font-size: 14px;
  }

  .day-event-subtitle {
    font-size: 12px;
  }

  .day-event-actions {
    width: 100%;
    justify-content: flex-end;
  }

  .day-event-actions > button {
    padding: 3px 8px;
  }

  .appointment-details-grid {
    grid-template-columns: 1fr;
  }

  .appointment-details-header {
    flex-direction: column;
    align-items: flex-start;
  }

  .appointment-create-actions .add-button {
    width: 100%;
    min-width: 0;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Agendamento/agendamento.css"],"names":[],"mappings":"AAAA;EACE,4BAA4B;EAC5B,UAAU;EACV,uBAAuB;AAKzB;;AAHE;IACE,iCAAiC;EACnC;;AAGF;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AAKX;;AAHE;IACE,gBAAgB;EAClB;;AAGF;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,WAAW;EACX,kBAAkB;AAiCpB;;AA/BE;IACE,aAAa;IACb,mBAAmB;IACnB,SAAS;EAYX;;AAVE;MACE,4BAA4B;MAC5B,eAAe;MACf,gBAAgB;MAChB,gBAAgB;IAKlB;;AAHE;QACE,yBAAyB;MAC3B;;AAIJ;IACE,gBAAgB;IAChB,cAAc;IACd,YAAY;EAUd;;AARE;MACE,yCAAyC;MACzC,kBAAkB;MAClB,eAAe;MACf,iBAAiB;MACjB,4BAA4B;;IAE9B;;AAIJ;EACE,yBAAyB;AAC3B;;AAEA;EACE,uCAAuC;EACvC,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,MAAM;EACN,uCAAuC;EACvC,WAAW;EACX,YAAY;EACZ,2CAA2C;EAC3C,gBAAgB;EAChB,yBAAyB;EACzB,4CAA4C;AAC9C;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,8BAA8B;EAC9B,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,2BAA2B;EAC3B,gBAAgB;EAChB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;EACf,WAAW;EACX,kBAAkB;AACpB;;AAEA,oCAAoC;AACpC;EACE,4BAA4B;EAC5B,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;EAC7B,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;EAC5B,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;EACpC,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,6BAA6B;EAC7B,gBAAgB;AAwBlB;;AAtBE;IACE,YAAY;IACZ,eAAe;EACjB;;AAEA;IACE,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;EACjB;;AAEA;IACE,gBAAgB;IAChB,4BAA4B;IAC5B,UAAU;IACV,eAAe;IACf,YAAY;;;EAGd;;AAGF;EACE,qBAAqB;AAYvB;;AAVE;IACE,gBAAgB;IAChB,4BAA4B;IAC5B,gBAAgB;IAChB,uCAAuC;IACvC,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,QAAQ;EACV;;;;AAKF,kBAAkB;AAClB;EACE,mCAAmC;AACrC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,wBAAwB;AAC1B;;;AAGA,oCAAoC;AACpC;EACE;IACE,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,gDAAgD;EAClD;;EAEA;IACE,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,QAAQ;EACV;;EAEA;IACE,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;EACzB;AACF;;AAEA;EACE;IACE,YAAY;IACZ,gBAAgB;EAClB;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,kCAAkC;EAClC,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,kCAAkC;EAClC,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,kCAAkC;EAClC,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb,gBAAgB;EAChB,qBAAqB;EACrB,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AAIX;;AAHE;;AAJF;IAKI,aAAa;AAEjB;EADE;;AAGF;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,UAAU;EACV,gBAAgB;EAChB,QAAQ;AACV;;AAEA;;EAEE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,UAAU;EACV,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,yBAAyB;EACzB,qBAAqB;EACrB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,WAAW;EACX,SAAS;EACT,QAAQ;EACR,sBAAsB;EACtB,qBAAqB;EACrB,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,gBAAgB;AAkBlB;;AAhBE;IACE,WAAW;IACX,mBAAmB;EACrB;;AAEA;IACE,8BAA8B;IAC9B,WAAW;IACX,YAAY;EACd;;AAEA;IACE,iCAAiC;IACjC,WAAW;IACX,YAAY;EACd;;AAGF;EACE,8BAA8B;EAC9B,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,uCAAuC;EACvC,4BAA4B;EAC5B,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,SAAS;EACT,kBAAkB;EAClB,qCAAqC;EACrC,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,QAAQ;EACR,uBAAuB;EACvB,yBAAyB;EACzB,8BAA8B;EAC9B,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,oFAAoF;AACtF;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,wCAAwC;EACxC,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE;IACE,eAAe;IACf,SAAS;EACX;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;IACT,mBAAmB;EACrB;;EAEA;IACE,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,WAAW;IACX,yBAAyB;EAC3B;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,sBAAsB;IACtB,QAAQ;IACR,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,yBAAyB;EAC3B;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;AACF","sourcesContent":[".search-results {\n  max-height: 400px !important;\n  z-index: 1;\n  box-shadow: 0px 0px 3px;\n\n  >div {\n    background-color: #fff !important;\n  }\n}\n\n.schedule-header-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n\n  >.h4-title {\n    margin-bottom: 0;\n  }\n}\n\n.schedule-filter {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.calendar-navigation {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n  margin: 40px 0 5px;\n\n  >.calendar-month-title {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n\n    >h2 {\n      color: var(--texto-destaque);\n      font-size: 18px;\n      font-weight: 800;\n      margin-left: 5px;\n\n      &::first-letter {\n        text-transform: uppercase;\n      }\n    }\n  }\n\n  >div>button {\n    background: none;\n    padding: 0 5px;\n    border: none;\n\n    .i {\n      border: 1.8px solid var(--texto-destaque);\n      border-radius: 50%;\n      font-size: 20px;\n      padding: 6px 10px;\n      color: var(--texto-destaque);\n\n    }\n  }\n}\n\n.calendar-navigation.day-mode {\n  justify-content: flex-end;\n}\n\n.calendar-month-count {\n  background-color: var(--texto-destaque);\n  color: #fff;\n  font-size: 12px;\n  font-weight: 700;\n  padding: 3px 10px;\n  border-radius: 999px;\n  white-space: nowrap;\n}\n\n.calendar-grid {\n  display: grid;\n  grid-template-columns: repeat(7, 1fr);\n  gap: 0;\n  /* Remove o espaçamento entre os dias */\n  width: 100%;\n  height: 100%;\n  /* Garante que o grid ocupe toda a altura */\n  overflow-y: auto;\n  border-collapse: collapse;\n  /* Faz com que as bordas fiquem encostadas */\n}\n\n.calendar-header {\n  font-weight: bold;\n  text-align: center;\n  padding: 10px;\n}\n\n.calendar-day {\n  background: #fff;\n  padding: 10px;\n  text-align: center;\n  cursor: pointer;\n  position: relative;\n  min-height: 100px;\n  border: 1px solid var(--borda);\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: flex-start;\n  min-width: 120px;\n  /* Largura mínima */\n  box-sizing: border-box;\n}\n\n.calendar-day.active:hover {\n  background: #e2e2e2;\n}\n\n.calendar-day span {\n  display: block;\n  margin-bottom: 5px;\n}\n\n.appointment-summary {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.appointment-summary span {\n  font-size: 12px;\n  font-weight: bold;\n  padding: 2px 4px;\n  border-radius: 4px;\n  color: white;\n}\n\n.summary-pending {\n  background-color: #f0ad4e;\n}\n\n.summary-done {\n  background-color: #5cb85c;\n}\n\n.summary-canceled {\n  background-color: #d9534f;\n}\n\n.summary-warning {\n  background-color: #f7dc6f;\n}\n\n.summary-expired {\n  background-color: #d9534f;\n}\n\n.calendar-day .appointment-tag {\n  color: var(--texto);\n  margin-top: 5px;\n  border-radius: 5px;\n  padding: 2px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  font-size: 12px;\n  width: 100%;\n  text-align: center;\n}\n\n/* Cores dos status de agendamento */\n.appointment-done {\n  background-color: lightgreen;\n  padding: 0 4px;\n  border-radius: 8px;\n}\n\n.appointment-pending {\n  background-color: lightsalmon;\n  padding: 0 4px;\n  border-radius: 8px;\n}\n\n.appointment-canceled {\n  background-color: #d9534f;\n  color: #fff;\n  padding: 0 4px;\n  border-radius: 8px;\n}\n\n.appointment-expired {\n  background-color: lightcoral;\n  padding: 0 4px;\n  border-radius: 8px;\n}\n\n.appointment-warning {\n  background-color: rgb(248, 248, 115);\n  padding: 0 4px;\n  border-radius: 8px;\n}\n\n.status-agendamentos {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  border-bottom: 1px solid #ccc;\n  margin-top: 10px;\n\n  >p:nth-of-type(1) {\n    width: 200px;\n    font-size: 15px;\n  }\n\n  >p:nth-of-type(2) {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    font-size: 14px;\n  }\n\n  >button {\n    background: none;\n    color: var(--texto-destaque);\n    padding: 0;\n    font-size: 16px;\n    border: none;\n\n    \n  }\n}\n\n.add-appointment-button {\n  margin: -9px 20px 0 0;\n\n  >button {\n    background: none;\n    color: var(--texto-destaque);\n    font-weight: 400;\n    border: 1px solid var(--texto-destaque);\n    padding: 4px 10px;\n    display: flex;\n    align-items: center;\n    gap: 6px;\n  }\n}\n\n\n\n/* Hover effects */\n.appointment-pending:hover {\n  background-color: rgb(252, 133, 86);\n}\n\n.appointment-done:hover {\n  background-color: rgb(115, 237, 115);\n}\n\n.appointment-canceled:hover {\n  background-color: #c9302c;\n}\n\n.appointment-expired:hover {\n  background-color: rgb(239, 109, 109);\n}\n\n.appointment-warning:hover {\n  background-color: yellow;\n}\n\n\n/* Resposta a dispositivos menores */\n@media (max-width: 800px) {\n  .calendar-day {\n    min-width: 0;\n    max-width: unset;\n    padding: 6px 4px;\n    min-height: 84px;\n  }\n\n  .calendar-grid {\n    grid-template-columns: repeat(7, minmax(0, 1fr));\n  }\n\n  .calendar-header {\n    padding: 8px 4px;\n    font-size: 16px;\n  }\n\n  .calendar-day > span {\n    font-size: 14px;\n    margin-bottom: 3px;\n  }\n\n  .appointment-summary {\n    width: 100%;\n    gap: 3px;\n  }\n\n  .appointment-summary span {\n    width: 100%;\n    font-size: 10px;\n    padding: 2px 3px;\n    line-height: 1.2;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  }\n}\n\n@media (max-width: 500px) {\n  .calendar-day {\n    min-width: 0;\n    max-width: unset;\n  }\n}\n\n.appointment-details {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  margin-top: 40px;\n}\n\n.appointment-details-modal {\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n  padding: 4px 2px;\n}\n\n.appointment-details-header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 12px;\n  border: 1px solid var(--ui-border);\n  border-radius: 12px;\n  background: #f8faff;\n  padding: 12px;\n}\n\n.appointment-details-header h4 {\n  margin: 4px 0 0;\n  color: var(--ui-text);\n}\n\n.appointment-details-label {\n  margin: 0;\n  font-size: 11px;\n  font-weight: 700;\n  color: var(--ui-muted);\n  text-transform: uppercase;\n  letter-spacing: .4px;\n}\n\n.appointment-details-status {\n  font-size: 12px;\n  font-weight: 700;\n  border-radius: 999px;\n  padding: 6px 10px;\n  white-space: nowrap;\n}\n\n.appointment-details-grid {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 10px;\n}\n\n.appointment-details-card {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  border: 1px solid var(--ui-border);\n  border-radius: 10px;\n  background: #fff;\n  padding: 10px;\n}\n\n.appointment-details-card span {\n  font-size: 11px;\n  font-weight: 700;\n  color: var(--ui-muted);\n  text-transform: uppercase;\n}\n\n.appointment-details-card strong {\n  color: var(--ui-text);\n  font-size: 14px;\n  overflow-wrap: anywhere;\n  word-break: break-word;\n}\n\n.appointment-details-block {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.appointment-details-text {\n  border: 1px solid var(--ui-border);\n  border-radius: 10px;\n  background: #fff;\n  padding: 10px;\n  min-height: 58px;\n  white-space: pre-wrap;\n  overflow-wrap: anywhere;\n  word-break: break-word;\n}\n\n.appointment-form {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  @media (max-width: 500px) {\n    margin-top: 0;\n  }\n}\n\n.appointment-create-modal {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.appointment-create-block {\n  border: 1px solid #e4eaf4;\n  border-radius: 12px;\n  background: #fff;\n  padding: 10px 12px;\n}\n\n.appointment-selected-internal {\n  margin-top: 8px;\n  border-top: 1px solid #edf1f7;\n  padding-top: 8px;\n}\n\n.appointment-create-form .appointment-details-grid {\n  border: 1px solid #e4eaf4;\n  border-radius: 12px;\n  background: #fff;\n  padding: 10px;\n  gap: 12px;\n}\n\n.appointment-create-form .appointment-details-card {\n  border: none;\n  background: transparent;\n  padding: 0;\n  border-radius: 0;\n  gap: 4px;\n}\n\n.appointment-create-form .appointment-details-card select,\n.appointment-create-form textarea {\n  width: 100%;\n  margin-top: 6px;\n}\n\n.appointment-virtual-card {\n  justify-content: center;\n}\n\n.appointment-virtual-field {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin-top: 6px;\n}\n\n.appointment-virtual-label {\n  font-size: 13px;\n  font-weight: 600;\n  color: #6b7a90;\n  min-width: 32px;\n  text-align: center;\n}\n\n.appointment-virtual-label.active {\n  color: #1c3faa;\n}\n\n.appointment-virtual-toggle {\n  position: relative;\n  width: 44px;\n  height: 24px;\n  display: inline-block;\n}\n\n.appointment-virtual-toggle input {\n  opacity: 0;\n  width: 0;\n  height: 0;\n}\n\n.appointment-virtual-slider {\n  position: absolute;\n  cursor: pointer;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: #cfd8ee;\n  transition: 0.2s ease;\n  border-radius: 999px;\n}\n\n.appointment-virtual-slider::before {\n  position: absolute;\n  content: \"\";\n  height: 18px;\n  width: 18px;\n  left: 3px;\n  top: 3px;\n  background-color: #fff;\n  transition: 0.2s ease;\n  border-radius: 50%;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);\n}\n\n.appointment-virtual-toggle input:checked + .appointment-virtual-slider {\n  background-color: #1c6ef2;\n}\n\n.appointment-virtual-toggle input:checked + .appointment-virtual-slider::before {\n  transform: translateX(20px);\n}\n\n.appointment-create-actions {\n  display: flex;\n  justify-content: flex-end;\n}\n\n.appointment-create-actions .add-button {\n  min-width: 210px;\n  border-radius: 10px;\n}\n\n.appointment-details .buttons-agenda-view {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n  margin-top: 20px;\n\n  >button {\n    width: 100%;\n    border-radius: 12px;\n  }\n\n  .btn-atender {\n    background-color: var(--verde);\n    color: #fff;\n    border: none;\n  }\n  \n  .btn-cancelar {\n    background-color: var(--Vermelho);\n    color: #fff;\n    border: none;\n  }\n}\n\n.appointment-form .form-group button {\n  background-color: var(--verde);\n  color: #fff;\n  border: none;\n}\n\n.calendar-month-actions {\n  display: flex;\n  align-items: center;\n}\n\n.day-view-actions {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  flex-wrap: wrap;\n  justify-content: flex-end;\n}\n\n.day-view-actions > button {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  border: 1px solid var(--texto-destaque);\n  color: var(--texto-destaque);\n  background: #fff;\n  border-radius: 10px;\n  padding: 8px 12px;\n  font-size: 14px;\n}\n\n.day-view-actions > button .icon {\n  width: 14px;\n  height: 14px;\n}\n\n.day-back-icon {\n  font-size: 14px;\n}\n\n.day-schedule-container {\n  width: 100%;\n  background: #fff;\n  border: 1px solid var(--borda);\n  border-radius: 12px;\n  overflow: hidden;\n}\n\n.day-schedule-header {\n  display: flex;\n  align-items: baseline;\n  gap: 10px;\n  padding: 14px 16px;\n  border-bottom: 1px solid var(--borda);\n  background: #f7f9fc;\n}\n\n.day-schedule-header > p {\n  margin: 0;\n  font-size: 12px;\n  font-weight: 700;\n  color: #6e7c91;\n}\n\n.day-schedule-header > h3 {\n  margin: 0;\n  font-size: 22px;\n  color: var(--texto-destaque);\n}\n\n.day-schedule-grid {\n  max-height: 68vh;\n  overflow-y: auto;\n}\n\n.day-schedule-list {\n  padding: 10px;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.day-event-card {\n  display: flex;\n  justify-content: space-between;\n  gap: 8px;\n  align-items: flex-start;\n  border: 1px solid #dbe4f2;\n  border-left: 4px solid #265daf;\n  border-radius: 8px;\n  padding: 8px 10px;\n  background: #fafdff;\n  cursor: pointer;\n  transition: transform 0.15s ease, box-shadow 0.15s ease, background-color 0.15s ease;\n}\n\n.day-event-card:hover {\n  background: #f2f7ff;\n  transform: translateY(-1px);\n  box-shadow: 0 4px 10px rgba(38, 93, 175, 0.12);\n}\n\n.day-event-card:focus-visible {\n  outline: 2px solid var(--texto-destaque);\n  outline-offset: 2px;\n}\n\n.day-event-card.day-card-appointment-done {\n  border-left-color: #5cb85c;\n}\n\n.day-event-card.day-card-appointment-pending {\n  border-left-color: #f0ad4e;\n}\n\n.day-event-card.day-card-appointment-warning {\n  border-left-color: #f7dc6f;\n}\n\n.day-event-card.day-card-appointment-expired {\n  border-left-color: #d9534f;\n}\n\n.day-event-card.day-card-appointment-canceled {\n  border-left-color: #8e8e8e;\n}\n\n.day-event-time {\n  margin: 0;\n  font-size: 12px;\n  font-weight: 700;\n  color: #5f6f8a;\n}\n\n.day-event-title {\n  margin: 2px 0 0;\n  font-weight: 700;\n  color: #1f4280;\n}\n\n.day-event-subtitle {\n  margin: 2px 0 0;\n  font-size: 13px;\n  color: #405371;\n}\n\n.day-event-actions {\n  display: flex;\n  gap: 8px;\n  align-items: center;\n  justify-content: flex-end;\n  flex-wrap: nowrap;\n}\n\n.day-event-actions .appointment-item {\n  width: auto;\n  max-width: 100%;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  flex-shrink: 1;\n}\n\n@media (max-width: 800px) {\n  .schedule-header-row {\n    flex-wrap: wrap;\n    gap: 10px;\n  }\n\n  .calendar-navigation {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 10px;\n    margin: 16px 0 10px;\n  }\n\n  .calendar-navigation .calendar-month-title h2 {\n    margin-left: 0;\n    font-size: 18px;\n  }\n\n  .calendar-navigation.day-mode {\n    align-items: flex-end;\n  }\n\n  .day-view-actions {\n    width: 100%;\n    justify-content: flex-end;\n  }\n\n  .day-view-actions > button {\n    justify-content: center;\n  }\n\n  .day-event-card {\n    flex-direction: column;\n    gap: 6px;\n    padding: 8px;\n  }\n\n  .day-event-title {\n    font-size: 14px;\n  }\n\n  .day-event-subtitle {\n    font-size: 12px;\n  }\n\n  .day-event-actions {\n    width: 100%;\n    justify-content: flex-end;\n  }\n\n  .day-event-actions > button {\n    padding: 3px 8px;\n  }\n\n  .appointment-details-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .appointment-details-header {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n\n  .appointment-create-actions .add-button {\n    width: 100%;\n    min-width: 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
